import { useState, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import "./header.css";

const Header = () => {
  const history = useHistory();
  const [showBackBtn, setshowBackBtn] = useState<boolean>(
    history.location.pathname === "/"
  );
  const [showHeader, setshowHeader] = useState<boolean>(true);

  useEffect(() => {
    const hideParam = new URL(document.location.href).searchParams.get(
      "hide-header"
    );
    setshowHeader(hideParam ? false : true);
  }, []);

  history.listen((location, action) => {
    if (location.pathname === "/") {
      setshowBackBtn(true);
    } else if (location.pathname === "/thank-you") {
      setshowBackBtn(true);
    } else {
      setshowBackBtn(false);
    }
  });

  return (
    <div className="mainHeader-wrapper">
      <header className="mainHeader">
        <div>
          {showBackBtn ? (
            ""
          ) : (
            <a onClick={() => history.goBack()} className="nav-back">
              <i className="icon-undo2"></i>
            </a>
          )}
        </div>
        {!showHeader ? (
          <>
            <div />
            <div />
          </>
        ) : (
          <>
            <Link to="/" className="logo">
              <img
                src={
                  process.env.REACT_APP_BASE_URL +
                  "/assets/images/nl-logo-white.svg"
                }
                alt="logo"
              />
            </Link>
            <div>
              <div className="header-call-wrapper">
                <div className="header-call">
                  <span>Call us: </span>
                  <a className="header-number" href="tel:6307487515">
                    630.748.7515
                  </a>
                </div>
                <Link to="#" className="disclosure">
                  Disclaimer
                </Link>
              </div>
            </div>
          </>
        )}
      </header>
    </div>
  );
};

export default Header;
